<ul class="list-unstyled mb-0">
  @for (entityAddress of addressStrings(); track entityAddress) {
    <li>
      <ul class="grid-line-height list-unstyled mb-0">
        @for (entityAddressLine of entityAddress; track $index) {
          <li class="line-height-16">
            {{ entityAddressLine }}
          </li>
        }
      </ul>
    </li>
  }
</ul>
